require("../css/foundation.min.css");
require("../css/font-awesome.min.css");
//require("../css/fontes/fontes.css");

require('@fancyapps/fancybox/dist/jquery.fancybox.css');
require('slick-carousel/slick/slick.less');
require('slick-carousel/slick/slick-theme.less');

require("../css/style.less");


const $ = require('jquery');
window.jQuery = $;

const Backbone = require('backbone');


require('./routers/default');



var base = jQuery('base').attr('href').replace(location.protocol+'//'+location.hostname,'').replace(/^\//,'').replace(/\/$/,'')

Backbone.history.start({
	
	pushState:true,
	root: base
	
});

require('@fancyapps/fancybox');
require('slick-carousel');

$().fancybox({
	selector: '.fancybox',
	loop:true
});



//////////////////
// WEBPACK FOOTER
// ./js/index.js
// module id = 6
// module chunks = 0